export default class AssociatedQuestionnaire {
  questionCode: string
  dataType: string
  responses: {
    value: string
    responseText: null
    associatedQuestionnaires: null
  }[]

  constructor(questionCode: string, dataType: string, value: string) {
    this.questionCode = questionCode
    this.dataType = dataType
    this.responses = [
      {
        value,
        responseText: null,
        associatedQuestionnaires: null
      }
    ]
  }
}
